/**
 * HTML (legacy) corpora URLs — account id in the path when known, matching API nesting.
 * Workspace discovery stays at /corpora (no account segment).
 */

const ACCOUNT_CORPORA_IN_PATH = /^\/accounts\/(\d+)\/corpora(?:\/|$)/

/** @param {string} [pathname] */
export function accountIdFromCorporaBrowserPath(pathname = "") {
  const m = String(pathname).match(ACCOUNT_CORPORA_IN_PATH)
  return m ? m[1] : undefined
}

/** @param {string|number|null|undefined} accountId */
export function corporaIndexBrowserPath(accountId) {
  if (accountId != null && /^\d+$/.test(String(accountId))) {
    return `/accounts/${encodeURIComponent(String(accountId))}/corpora`
  }
  return "/corpora"
}

/**
 * @param {string|number|null|undefined} accountId
 * @param {string|number} slugOrId
 */
export function corpusShowBrowserPath(accountId, slugOrId) {
  const id = encodeURIComponent(String(slugOrId))
  if (accountId != null && /^\d+$/.test(String(accountId))) {
    return `/accounts/${encodeURIComponent(String(accountId))}/corpora/${id}`
  }
  return `/corpora/${id}`
}
